import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from "axios";

//import CustomDropDown from './customDropDown';

function AddSimpleSelectQues(props) {

    //Handling TP Dropdown
    const tpDropdown = useRef();

    //Handling Initial States Floating Labels
    const [formData, setFormData] = useState({
        //[name]: null,
    });


    //Handling Floating Labels
    const handleFloatingLabels = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));

        console.log(formData);
    }

    const { type, divClass, options, attachOther, verificationType, name, id, placeholder, fieldId, isRequired, errId, caseCheckId, returnType, value, hiddenValue, selectedLabel, checkDetailsIndex, fieldName, handleSelectChange } = props;

    console.log("opt", options);


    ///////////////////////////////////////////////////////////

    const [selectedOptionId, setSelectedOptionId] = useState();
    const [showFilterDiv, setShowFilterDiv] = useState(false);
    const [keyword, setKeyword] = useState("");
    const [runRequest, setRunRequest] = useState(false);
    const [autoSuggestOptionData, setAutoSuggestOption] = useState([]);
    const inputText = useRef();

    //   const inputTypeHandler = (e) => {
    //     setKeyword(e.target.value);
    //     setSelectedOptionId(null);
    //     setRunRequest(true);

    //     setFormData((prevState) => ({
    //       ...prevState,
    //       [e.target.name]: e.target.value,
    //     }));
    //   };

    const [currentSelectedVal, setCurrentSelectedVal] = useState(null);

    const handleThirdPartyFloatingLabel = (e) => {
        //console.log('test'+currentSelectedVal);
        let parent = e.target.parentElement;
        while (!parent.classList.contains('floating-label'))
            parent = parent.parentElement;

        if (parent.children[1].classList.contains('focused')) {
            if (currentSelectedVal !== null || value) {
                return false;
            } else {
                parent.children[1].classList.remove('focused');
                setCurrentSelectedVal(null);
            }
        } else {
            parent.children[1].classList.add('focused');
        }
    }



    const [reactSelect, setReactSelect] = useState();

    useEffect(() => {

        let stateValue = value;
        if (selectedLabel !== undefined) {
            stateValue = selectedLabel;
        }

        setReactSelect({ value: value, label: stateValue });
        // setFormData(() => ({
        //   [name + "_value"]: hiddenValue,
        // }));


    }, []);


    useEffect(() => {

        let stateValue = value;
        if (selectedLabel !== undefined) {
            stateValue = selectedLabel;
        }

        // setReactSelect({ value: value, label: stateValue });
        setFormData(() => ({
            [name + "_value"]: hiddenValue,
        }));


    }, [hiddenValue]);



    const handleChange = (e) => {

        e.preventDefault();

        //  alert(JSON.stringify(e.target.value));

        setCurrentSelectedVal(e.target.value);

        //  setReactSelect(selectedOption);

        let value = e.target.value;
        // if (returnType === 'name') {
        //     value = selectedOption.name;
        // }

        // var value_element = document.getElementById(name+"_value");
        // value_element.value = selectedOption.value;
        setFormData((prevState) => ({
            [name + "_value"]: value,
        }));

        // alert(JSON.stringify(value))

        props.selectOption([{ "name": name, "value": value, "fieldId": fieldId, "isRequired": isRequired, "err_id": errId, "caseCheckId": caseCheckId, "checkdetailsindex": checkDetailsIndex, "fieldname": fieldName }]);
        setShowFilterDiv(false);


    };


    let elementClass = 'col-sm-4 col-md-12 col-xl-4';
    if(divClass){
      elementClass = divClass;
    }
    



    return (
        <>

            {(() => {
                if (
                    type &&
                    type === 1
                ) {
                    return (
                        <>
                            <div className={elementClass}>
                                <div className="form-group">
                                    <div className="tp-dropdown" ref={tpDropdown}>

                                       <label htmlFor={id} className={'focused'}>{placeholder} {isRequired == 1 && <sup className="text-danger">*</sup>}</label>


                                        <select
                                            name={name}
                                            id={id}
                                            className="form-control"
                                            onChange={(e) => handleChange(e)}
                                            //onChange={handleChange}
                                            data-checkdetailsindex={checkDetailsIndex}
                                            data-fieldname={fieldName}
                                        >
                                            <option value="" disabled selected={!value}>Select option</option>
                                           

                                            {options &&
                                                options.map((option) => {
                                                    return (
                                                        <>
                                                            <option value={option.value} selected={value == option.value ? true : false}>{option.label}</option>
                                                        </>
                                                    );
                                                })}

                                        </select>

                                    

                                      

                                    </div>
                                    <p className="err text-danger" id={errId}></p>
                                    <input type="hidden" name={name + "_value"} id={id + "_value"} defaultValue={formData[name + "_value"]} />

                                </div>
                            </div>
                        </>
                    );
                } 
            })()}

        </>
    );
}

export default AddSimpleSelectQues;
